var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPercent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85355 2.14645C10.0488 2.34171 10.0488 2.65829 9.85355 2.85355L2.85355 9.85355C2.65829 10.0488 2.34171 10.0488 2.14645 9.85355C1.95118 9.65829 1.95118 9.34171 2.14645 9.14645L9.14645 2.14645C9.34171 1.95118 9.65829 1.95118 9.85355 2.14645Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 2.5C2.83579 2.5 2.5 2.83579 2.5 3.25C2.5 3.66421 2.83579 4 3.25 4C3.66421 4 4 3.66421 4 3.25C4 2.83579 3.66421 2.5 3.25 2.5ZM1.5 3.25C1.5 2.2835 2.2835 1.5 3.25 1.5C4.2165 1.5 5 2.2835 5 3.25C5 4.2165 4.2165 5 3.25 5C2.2835 5 1.5 4.2165 1.5 3.25Z",
    fill: "#60666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 8C8.33579 8 8 8.33579 8 8.75C8 9.16421 8.33579 9.5 8.75 9.5C9.16421 9.5 9.5 9.16421 9.5 8.75C9.5 8.33579 9.16421 8 8.75 8ZM7 8.75C7 7.7835 7.7835 7 8.75 7C9.7165 7 10.5 7.7835 10.5 8.75C10.5 9.7165 9.7165 10.5 8.75 10.5C7.7835 10.5 7 9.7165 7 8.75Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPercent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/percent.78a14e96e50cf97af4f285b1883dfe74.svg";